package com.ijoin.data.api

import com.ijoin.data.api.ApiClient.addAuthToken
import com.ijoin.data.model.MediaUploadRequest
import com.ijoin.data.model.MediaUploadResponse
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*

class MediaApi {
    private val client = ApiClient.client
    private val baseUrl = "${ApiClient.getBaseUrl()}/api/media"

    suspend fun uploadMedia(
        dataUrl: String,
        folderKey: String?,
        mediaType: String = "photos"
    ): Result<MediaUploadResponse> {
        val request = MediaUploadRequest(
            dataUrl = dataUrl,
            folderKey = folderKey,
            mediaType = mediaType
        )
        return safeApiCall {
            client.post("$baseUrl/upload") {
                addAuthToken()
                contentType(ContentType.Application.Json)
                setBody(request)
            }
        }.mapCatching { response -> response.body() }
    }
}
